

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LoginModal from "../main/loginModal/LoginModal";
import Head from "../Global/Head";
import Header from "../Global/Header";
import Footer from "../shared/footer/Footer";
import img1 from "../../images/blog1.jpg";
import img2 from "../../images/blog2.jpg";

const BlogSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mobileSearchBar, setMobileSearchBar] = useState(false);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (!isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };


  return (
    <>
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />
 <Header setIsVisible={setIsVisible} />

      <main className="mt-10">
        <div className="block md:flex md:space-x-2 px-2 lg:p-0">
          <Link
            className="mb-4 md:mb-0 w-full md:w-2/3 relative rounded inline-block"
            style={{ height: "24em" }}
            to="/blogs/1"
          >
            <div
              className="absolute left-0 bottom-0 w-full h-full z-10 rounded-[2rem]"
              style={{
                backgroundImage:
                  "linear-gradient(180deg,transparent,rgba(0,0,0,.7))",
              }}
            />
            <img
              src={img1}
              className="absolute left-0 top-0 w-full h-full rounded-[2rem] z-0 object-cover"
            />
            <div className="p-4 absolute bottom-0 left-0 z-20">
              <span className="px-4 py-1 bg-black text-gray-200 inline-flex items-center justify-center mb-2">
                Connection
              </span>
              <h2 className="text-4xl font-semibold text-gray-100 leading-tight">
                Why Hightable is More Than Just a Platform?
              </h2>
            </div>
          </Link>

          <Link
            className="w-full md:w-1/3 relative rounded-[2rem] hidden sm:inline"
            style={{ height: "24em" }}
            to="/blogs/2"
          >
            <div
              className="absolute left-0 top-0 w-full h-full z-10 rounded-[2rem] "
              style={{
                backgroundImage:
                  "linear-gradient(180deg,transparent,rgba(0,0,0,.7))",
              }}
            />
            <img
              src={img2}
              className="absolute left-0 top-0 w-full h-full rounded-[2rem] z-0 object-cover"
            />
            <div className="p-4 absolute bottom-0 left-0 z-20">
              <span className="px-4 py-1 bg-black text-gray-200 inline-flex items-center justify-center mb-2">
                Connection
              </span>
              <h2 className="text-3xl font-semibold text-gray-100 leading-tight">
                The Cost of Loneliness: Why Connection Matters More Than Ever
              </h2>
            </div>
          </Link>
        </div>

        <div className="block lg:flex lg:space-x-2 px-2 lg:p-0 mt-10 mb-10">
          {/* post cards */}
          <div className="w-full lg:w-2/3">
        <Link
          className="w-full md:w-1/3 relative rounded-[2rem]"
          style={{ height: "24em" }}
          to="/blogs/3"
        >
            <div className="rounded w-full lg:flex mb-10">
              <div
                className="h-48 lg:w-48 flex-none bg-cover rounded-[2rem] text-center overflow-hidden "
                style={{
                  backgroundImage:
                    'url("https://res.cloudinary.com/diecfwnp9/image/upload/v1761551273/WhatsApp_Image_2025-10-27_at_08.38.53_qff0ww.jpg")',
                }}
                title="deit is very important"
              ></div>
              <div className="bg-white rounded px-4 flex flex-col justify-between leading-normal">
                <div>
                  <div className="mt-3 md:mt-0 text-gray-700 font-bold text-2xl mb-2">
                    Conversation Starters: How to Spark Meaningful Connections
                  </div>
                  <p className="text-gray-700 text-base">
                    We all know the awkwardness of small talk—the endless, “Hi, how are you?” loop that never seems to go anywhere. Yet, conversation is the bridge to connection, and connection is at the heart of Hightable
                  </p>
                </div>
              </div>
            </div>

          </Link>

            <Link className="block rounded-[2rem] w-full lg:flex mb-10" to="/blogs/4">
              <div
                className="h-48 lg:w-48 flex-none bg-cover rounded-[2rem] text-center overflow-hidden "
                style={{
                  backgroundImage:
                    'url("https://res.cloudinary.com/diecfwnp9/image/upload/v1761551272/WhatsApp_Image_2025-10-27_at_08.38.51_n4ybwo.jpg")',
                }}
                title="deit is very important"
              ></div>
              <div className="bg-white rounded px-4 flex flex-col justify-between leading-normal">
                <div>
                  <div className="mt-3 md:mt-0 text-gray-700 font-bold text-2xl mb-2">
                    How to Make Friends in a Busy World
                  </div>
                  <p className="text-gray-700 text-base">
                    Making friends is easy in theory, but in reality, it often feels like a full-time job. Between work, errands, and endless scrolling, carving out space for genuine connection can seem impossible. Yet friendships are essential—not just for fun, but for mental health, creativity, and belonging.
                  </p>
                </div>
              </div>
            </Link>

            <Link to={"/blogs/5"} className="rounded-[2rem] w-full lg:flex mb-10">
              <div
                className="h-48 lg:w-48 flex-none bg-cover rounded-[2rem] text-center overflow-hidden "
                style={{
                  backgroundImage:
                    'url("https://res.cloudinary.com/diecfwnp9/image/upload/v1761403966/IMG_0971_iqalyw.jpg")',
                }}
                title="deit is very important"
              ></div>
              <div className="bg-white rounded px-4 flex flex-col justify-between leading-normal">
                <div>
                  <div className="mt-3 md:mt-0 text-gray-700 font-bold text-2xl mb-2">
                    Where Women Rise Together: Build Your Tribe on Hightable
                  </div>
                  <p className="text-gray-700 text-base">
                    In a world that constantly tells women to “do it all alone,” finding a supportive circle can feel like a superpower. Friendships, mentorship, and a tribe of like-minded women aren’t just nice-to-have—they’re essential for personal growth, confidence, and well-being.
                  </p>
                </div>
              </div>
            </Link>

              <Link to={"/blogs/6"} className="rounded-[2rem] w-full lg:flex mb-10">
              <div
                className="h-48 lg:w-48 flex-none bg-cover rounded-[2rem] text-center overflow-hidden "
                style={{
                  backgroundImage:
                    'url("https://res.cloudinary.com/diecfwnp9/image/upload/v1761551272/WhatsApp_Image_2025-10-27_at_08.38.52_2_prryyf.jpg")',
                }}
                title="deit is very important"
              ></div>
              <div className="bg-white rounded px-4 flex flex-col justify-between leading-normal">
                <div>
                  <div className="mt-3 md:mt-0 text-gray-700 font-bold text-2xl mb-2">
                    The Psychology of Belonging: Why We Crave Our Tribe

                  </div>
                  <p className="text-gray-700 text-base">
                   We live in the most connected era in history, yet loneliness has quietly become a modern epidemic. Scroll through your phone, and you’ll see hundreds of contacts. But how many of them would you really call at 2 AM when life feels heavy? That gap between connection and belonging is exactly what psychology has been trying to explain for decades.
 </p>
                </div>
              </div>
            </Link>
              <Link to={"/blogs/7"} className="rounded-[2rem] w-full lg:flex mb-10">
              <div
                className="h-48 lg:w-48 flex-none bg-cover rounded-[2rem] text-center overflow-hidden "
                style={{
                  backgroundImage:
                    'url("https://res.cloudinary.com/diecfwnp9/image/upload/v1761551272/WhatsApp_Image_2025-10-27_at_08.38.52_1_a725h2.jpg")',
                }}
                title="deit is very important"
              ></div>
              <div className="bg-white rounded px-4 flex flex-col justify-between leading-normal">
                <div>
                  <div className="mt-3 md:mt-0 text-gray-700 font-bold text-2xl mb-2">
                   Culture Eats Strategy for Breakfast: Why We Obsess Over Community
                  </div>
                  <p className="text-gray-700 text-base">
                  Peter Drucker’s famous line — “Culture eats strategy for breakfast” — is more than a clever quote. For us at Hightable, it’s a daily reminder that while strategies can be drawn on slides, culture is lived in every interaction. </p>
                </div>
              </div>
            </Link>
              <Link to={"/blogs/8"} className="rounded-[2rem] w-full lg:flex mb-10">
              <div
                className="h-48 lg:w-48 flex-none bg-cover rounded-[2rem] text-center overflow-hidden "
                style={{
                  backgroundImage:
                    'url("https://res.cloudinary.com/diecfwnp9/image/upload/v1761403960/IMG_0946_uqbotf.jpg")',
                }}
                title="deit is very important"
              ></div>
              <div className="bg-white rounded px-4 flex flex-col justify-between leading-normal">
                <div>
                  <div className="mt-3 md:mt-0 text-gray-700 font-bold text-2xl mb-2">
                    Hyper-Independence vs Interdependence: Finding the Balance
                  </div>
                  <p className="text-gray-700 text-base">
                We live in a world that celebrates independence—especially for women. “Do it yourself,” “handle it alone,” “be self-sufficient”—these messages are everywhere. While independence is empowering, taken to the extreme, it can become hyper-independence: a pattern where relying on anyone else feels uncomfortable or even threatening.    </p>
                </div>
              </div>
            </Link>
              <Link to={"/blogs/9"} className="rounded-[2rem] w-full lg:flex mb-10">
              <div
                className="h-48 lg:w-48 flex-none bg-cover rounded-[2rem] text-center overflow-hidden "
                style={{
                  backgroundImage:
                    'url("https://res.cloudinary.com/diecfwnp9/image/upload/v1761403965/IMG_0948_dq4pgl.jpg")',
                }}
                title="deit is very important"
              ></div>
              <div className="bg-white rounded px-4 flex flex-col justify-between leading-normal">
                <div>
                  <div className="mt-3 md:mt-0 text-gray-700 font-bold text-2xl mb-2">
                    Building Hightable: Chaos, Coffee, and Co-founder Banter
                  </div>
                  <p className="text-gray-700 text-base">
                    Startups are glamorous in Instagram posts and success stories—but the reality is often chaos wrapped in caffeine. That’s exactly how Hightable was built: with messy notebooks, endless coffee cups, and more debates than we can count.
 </p>
                </div>
              </div>
            </Link>
          </div>

          {/* right sidebar */}
          <div className="w-full lg:w-1/3 px-3">
            {/* sidebar content can go here */}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default BlogSection;

